<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="users-style">

            <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">
                Currency Settings
                <span>
                    <!-- alpha fix- maked the breadcum Currency Settings  -->
                    <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Currency Settings
                </span>
            </h4>

            <!-- Show Total Row Section -->
            <template v-if="$acl['add-conversion-currency'] > 1">
                <div class="row no-margin mt-4">
                    <div class="ibox col-md-12 px-4">
                        <div class="ibox-title dashboard_title px-0">
                            <h4>Show Total Row</h4>
                        </div>
                        <div class="ibox-content px-0 pt-3 pb-4">
                            <p class="mt-2">Option to show an additional total row in selected currency on payroll report:</p>

                            <div class="toggle_button_tax"  >
                                <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                        <input data-v-25adc6c0="" type="radio" v-model="report_total_row_setting" class="v-switch-input trz_tax_radio" name="report_total_row_setting" value="1">
                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                </div>
                                <div class="col-sm-5 trz_tax_button ">Enable</div>
                            </div>

                            <div class="toggle_button_tax mb-3">
                                <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                        <input data-v-25adc6c0="" type="radio" v-model="report_total_row_setting" class="v-switch-input trz_tax_radio" name="report_total_row_setting" value="2">
                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                </div>
                                <div class="col-sm-5 trz_tax_button">Disable</div>
                            </div>

                            <b-button id="show-btn" class="mb-5" @click="updateReportSettings()">Save</b-button>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Active Conversion Currency Section -->
            <div class="row no-margin mt-4">
                <div class="ibox col-md-12 px-4">
                    <div class="ibox-title dashboard_title px-0">
                        <h4>
                            Active Conversion Currency
                            <b-form-select v-model="currency_selected" :options="currency_lists" class="w-25 d-inline-block ml-3"></b-form-select>
                            <b-button id="show-btn" class="ml-3" @click="updateCurrency()" v-if="$acl['add-conversion-currency'] > 1">Update</b-button>
                        </h4>
                    </div>
                </div>
            </div>

            <!-- Currency Table Section -->
            <div class="row no-margin mt-4">
                <div class="ibox col-md-12 px-4">
                    <div class="ibox-title dashboard_title px-0">
                        <b-alert show dismissible fade v-if="successmsg">{{ successmsg }}</b-alert>
                        <h4>Currencies</h4>
                    </div>

                    <div class="ibox-content px-0 pt-4 employee-table-wrapper">
                        <div class="row no-gutters py-2 mb-3 pl-0">
                            <div class="col-sm-6">
                                <div class="custom-search">
                                    <b-input-group class="mb-0">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="search"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" placeholder="Search Currency" v-model="search" @input="resetPagination()"></b-form-input>
                                    </b-input-group>
                                </div>
                            </div>
                            <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">
                                <b-button id="show-btn" @click="addCurrency()" v-if="$acl['add-conversion-currency'] > 1">Add Currency</b-button>
                            </div>
                        </div>

                        <!-- Add Currency Form -->
                        <div v-if="addcurrencyshow" class="mb-4 px-2">
                            <template v-if="$acl['add-conversion-currency'] > 1">
                                <div class="text mb-3 border-bottom pb-3" style="font-size: large; color: var(--primary_color);">
                                    Add Currency
                                </div>
                                <b-form @submit.prevent="submitCurrency">
                                    <b-form-group id="code-group" label="Code (all caps)" label-for="code" class="required-field">
                                        <b-form-input id="code" name="code" v-model="fdatacurrency.code"
                                            v-validate="{required: true, max: 7, regex:/^[A-Z]+$/}"
                                            :state="validateState('code')"
                                            aria-describedby="code-feedback"
                                            data-vv-as="Code (all caps)">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="code-feedback">{{ veeErrors.first('code') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group id="full_form-group" label="Full Form" label-for="full_form" class="required-field">
                                        <b-form-input id="full_form" name="full_form" v-model="fdatacurrency.full_form"
                                            v-validate="{required: true, regex:/^[a-zA-Z\s]+$/}"
                                            :state="validateState('full_form')"
                                            aria-describedby="full_form-feedback"
                                            data-vv-as="Full Form">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="full_form-feedback">{{ veeErrors.first('full_form') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group id="status-group" label="Status" label-for="status" class="required-field">
                                        <b-form-select id="status" name="status" v-model="fdatacurrency.status"
                                            :options="currency_status" class="w-100"
                                            v-validate="{required: true}"
                                            :state="validateState('status')"
                                            aria-describedby="status-feedback"
                                            data-vv-as="Status">
                                        </b-form-select>
                                        <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                    <div class="d-flex justify-content-center" style="margin-top: 30px;">
                                        <b-button type="submit" name="submit_currency" variant="primary" class="mr-3">Add Currency</b-button>
                                        <b-button @click="cancelcurrency()">Cancel</b-button>
                                    </div>
                                </b-form>
                            </template>
                        </div>

                        <!-- Currency Table -->
                        <table class="table dataTable no-sort-icon leave-table">
                            <thead>
                                <tr class="table-head">
                                    <td>Code</td>
                                    <td>Full Form</td>
                                    <td>Status</td>
                                    <!-- alpgha fix- maked text center  -->
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="item in paginatedData" :key="item.id">
                                    <td>{{ item.code }}</td>
                                    <td>{{ item.full_form }}</td>
                                    <td>{{ item.status }}</td>
                                    <td>
                                        <div class="float-right position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <b-icon icon="three-dots-vertical"></b-icon>
                                                </a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">
                                                        <b-button variant="outline-secondary" @click="addRates(item.code)">
                                                            <b-icon icon="cash"></b-icon> Rates
                                                        </b-button>
                                                        <b-button variant="outline-secondary" @click="deleteCurrency(item.code)" v-if="$acl['add-conversion-currency'] > 1">
                                                            <b-icon icon="trash"></b-icon> Delete
                                                        </b-button>
                                                        <template v-if="$acl['add-conversion-currency'] > 1">
                                                            <!-- <b-button variant="outline-secondary" @click="updateStatus(item.code, 'Inactive')" v-if="item.status == 'Active'">
                                                                Inactivate
                                                            </b-button>
                                                            <b-button variant="outline-secondary" @click="updateStatus(item.code, 'Active')" v-else>
                                                                Activate
                                                            </b-button> -->
                                                            <b-button variant="outline-secondary" @click="updateStatus(item.code, 'Inactive')" v-if="item.status == 'Active'"><b-icon icon="x-circle" class="mr-1"></b-icon>
                                                                Inactivate
                                                            </b-button>
                                                            <b-button variant="outline-secondary" @click="updateStatus(item.code, 'Active')" v-else><b-icon icon="check-circle" class="mr-1"></b-icon>
                                                                Activate
                                                            </b-button>
                                                        </template>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled">
                                    <b-form-select v-model="length" :options="length_options"></b-form-select>
                                </li>
                                <li class="page-item disabled m-2">per page. Total {{ currencies.length }} records found.</li>
                            </ul>
                            <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Rates Modal -->
        <b-modal id="addRates" title="Rates" size="lg" hide-footer>
            <div>
                <div class="row no-gutters py-2 mb-3">
                    <div class="col-sm-6">
                        <div class="custom-search">
                            <b-input-group class="mb-0">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search Rates" v-model="rate_search" @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="col-sm-6 pr-0 text-right company-form-box-title">
                        <b-button id="show-btn" @click="addRatesvalue()" v-if="$acl['add-conversion-currency'] > 1">Add Rate</b-button>
                    </div>
                </div>

                <!-- Add Rate Form -->
                <div v-if="addrateshow" class="mb-4">
                    <template v-if="$acl['add-conversion-currency'] > 1">
                        <div class="w-100 p-1">
                            <div class="text mb-3 border-bottom pb-3" style="font-size: large; color: var(--primary_color);">
                                Add Rate
                            </div>
                            <b-form @submit.prevent="submitRate">
                                <div class="row mt-1">
                                    <div class="col-6 p-3">
                                        <b-form-group id="month-group" label="Month" label-for="month" class="required-field">
                                            <b-form-select name="month" v-model="fdata_rates.month" :options="month_options"
                                                v-validate="{required: true}"
                                                :state="validateState('month')"
                                                aria-describedby="month-feedback"
                                                data-vv-as="Month">
                                            </b-form-select>
                                            <b-form-invalid-feedback id="month-feedback">{{ veeErrors.first('month') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-6 p-3">
                                        <b-form-group id="year-group" label="Year" label-for="year" class="required-field">
                                            <b-form-select name="year" v-model="fdata_rates.year" :options="year"
                                                v-validate="{required: true}"
                                                :state="validateState('year')"
                                                aria-describedby="year-feedback"
                                                data-vv-as="Year">
                                            </b-form-select>
                                            <b-form-invalid-feedback id="year-feedback">{{ veeErrors.first('year') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-6 p-3">
                                        <b-form-group id="currency-group" label="Currency" label-for="currency">
                                            <b-form-input id="currency" name="currency" v-model="fdata_rates.code"
                                                v-validate="{required: true, regex:/^[+]?\d*(\.\d+)?$/}"
                                                :state="validateState('currency')"
                                                aria-describedby="currency-feedback"
                                                data-vv-as="Currency" disabled>
                                            </b-form-input>
                                            <b-form-invalid-feedback id="currency-feedback">{{ veeErrors.first('currency') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-6 p-3">
                                        <b-form-group id="local_eq_rate-group" label="Rates (BDT)" label-for="local_eq_rate" class="required-field">
                                            <b-form-input id="local_eq_rate" name="local_eq_rate" v-model="fdata_rates.local_eq_rate"
                                                v-validate="{required: true}"
                                                :state="validateState('local_eq_rate')"
                                                aria-describedby="local_eq_rate-feedback"
                                                data-vv-as="Rates(BDT)">
                                            </b-form-input>
                                            <b-form-invalid-feedback id="local_eq_rate-feedback">{{ veeErrors.first('local_eq_rate') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <b-button type="submit" name="submit_rates" variant="primary" class="mr-3">Save</b-button>
                                    <b-button @click="cancelcurrency()">Cancel</b-button>
                                </div>
                            </b-form>
                        </div>
                    </template>
                </div>

                <!-- Rates Table -->
                <table class="table dataTable no-sort-icon leave-table">
                    <thead>
                        <tr class="table-head">
                            <td>Currency</td>
                            <td>Month</td>
                            <td>Year</td>
                            <td>Rates (BDT)</td>
                            <!-- alpha fix- maked text center  -->
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="item in paginatedDataRates" :key="item.id">
                            <td>{{ item.code }}</td>
                            <td>{{ item.month }}</td>
                            <td>{{ item.year }}</td>
                            <td>{{ item.local_eq_rate }}</td>
                            <td>
                                <div class="float-right position-relative">
                                    <b-button-toolbar>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <b-icon icon="three-dots-vertical"></b-icon>
                                        </a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mr-0">
                                                <b-button variant="outline-secondary" @click="deleteRate(item.code, item.month_value, item.year)" v-if="$acl['add-conversion-currency'] > 1">
                                                    <b-icon icon="trash"></b-icon> Delete
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="paginatedDataRates.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                <div v-else class="px-3">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled">
                            <b-form-select v-model="rates_length" :options="length_options"></b-form-select>
                        </li>
                        <li class="page-item disabled m-2">per page. Total {{ rates_data.length }} records found.</li>
                    </ul>
                    <b-pagination-nav v-model="rates_pagination.currentPage" :number-of-pages="rates_pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>
                </div>
            </div>
        </b-modal>

    </b-overlay>
</template>

<script>
export default {
    data() {
        return {
            addcurrencyshow: '',
            currencies: [],
            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            edit_user: false,
            disableme: false,
            showoverlay: false,
            costdata: {
                id: null,
                name: '',
                code: '',
                short_code: '',
                status: ''
            },
            status: [
                { value: null, text: "Select..." },
                { value: "0", text: "Disabled" },
                { value: "1", text: "Enabled" },
            ],
            search: '',
            rate_search: '',
            blankmsg: 'Fetching data..',
            blankmsgrates: 'Fetching data..',
            sortKey: 'reorder',
            length: 20,
            // Abdullah26 maked it 20
            rates_length: 20,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            rates_pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            currency_lists: [],
            currency_selected: 0,
            fdatacurrency: {},
            currency_status: [
                { value: 'Active', text: 'Active' },
                { value: 'Inactive', text: 'Inactive' },
                { value: 'Pending', text: 'Pending' },
            ],
            rates_data: [],
            fdata_rates: {},
            current_currency: '',
            addrateshow: '',
            selected_year: null,
            year: [],
            selected_month: 1,
            month_options: [
                { value: 1, text: 'January' },
                { value: 2, text: 'February' },
                { value: 3, text: 'March' },
                { value: 4, text: 'April' },
                { value: 5, text: 'May' },
                { value: 6, text: 'June' },
                { value: 7, text: 'July' },
                { value: 8, text: 'August' },
                { value: 9, text: 'September' },
                { value: 10, text: 'October' },
                { value: 11, text: 'November' },
                { value: 12, text: 'December' },
            ],
            // Sohel: New mappings update
            report_total_row_setting: 2,
            // Sohel: New mappings update
        }
    },
    methods: {
        retespaginate(array, length, pageNumber) {
            let l = parseInt(array.length);
            let m = parseInt(length);
            this.rates_pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.rates_pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.rates_pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.rates_pagination.nextPage = array.length > this.rates_pagination.to ? pageNumber + 1 : '';
            if (l > 0) {
                this.rates_pagination.pages = Math.ceil(l / m);
            }
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        addRatesvalue() {
            this.fdata_rates = {};
            this.fdata_rates.code = this.current_currency;
            this.addrateshow = true;
        },
        cancelcurrency() {
            this.addcurrencyshow = '';
            this.addrateshow = '';
        },
        addCurrency() {
            this.fdata = {};
            this.addcurrencyshow = !this.addcurrencyshow;
        },
        submitCurrency(e) {
            e.preventDefault();
            this.$validator.validateAll().then(result => {
                if (!result) return;
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdatacurrency)) {
                    formData.append(`${key}`, `${value}`);
                }
                this.showoverlay = true;
                axios.post(this.$api_url + '/add-conversion-currency', formData)
                    .then(function (response) {
                        if (response.data.success) {
                            this.$bvToast.toast("Saved successfully!", { title: `Success`, variant: 'success', solid: true });
                            this.resetForm();
                            this.getAllCurrencies();
                        } else {
                            let msg = response.data.message ? response.data.message : 'Failed!';
                            this.$bvToast.toast(msg, { title: `Failed`, variant: 'danger', solid: true });
                        }
                        this.cancelcurrency();
                    }.bind(this))
                    .catch(function (error) { currentObj.serverError(error); });
                this.showoverlay = false;
            });
        },
        submitRate(e) {
            e.preventDefault();
            this.$validator.validateAll().then(result => {
                if (!result) return;
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata_rates)) {
                    formData.append(`${key}`, `${value}`);
                }
                this.showoverlay = true;
                axios.post(this.$api_url + '/add-conversion-rate', formData)
                    .then(function (response) {
                        if (response.data.success) {
                            this.$bvToast.toast("Saved successfully!", { title: `Success`, variant: 'success', solid: true });
                            this.resetForm();
                            this.getCurrencyRates();
                        } else {
                            let msg = response.data.message ? response.data.message : 'Failed!';
                            this.$bvToast.toast(msg, { title: `Failed`, variant: 'danger', solid: true });
                        }
                    }.bind(this))
                    .catch(function (error) { currentObj.serverError(error); });
                this.showoverlay = false;
            });
        },
        addRates(for_rate) {
            this.current_currency = for_rate;
            this.fdata_rates = {};
            this.fdata_rates.code = this.current_currency;
            this.getCurrencyRates();
            this.cancelcurrency();
            this.$bvModal.show('addRates');
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetOptionsForm() {
            this.$nextTick(() => { this.$validator.reset(); });
        },
        resetAll() {
            this.cost_center_file = '';
        },
        resetForm() {
            this.fdatacurrency = {};
            this.$nextTick(() => { this.$validator.reset(); });
        },
        getCurrencyRates: function () {
            axios.get(this.$api_url + '/get-conversion-rates', {
                params: { code: this.current_currency }
            }).then(function (response) {
                this.rates_data = response.data;
                if (this.rates_data.length == 0) this.blankmsg = "Nothing found.";
            }.bind(this));
        },
        deleteRate: function (code, month, year) {
            this.$bvModal.msgBoxConfirm('Please confirm if you want to delete this rate.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            }).then(value => {
                if (value) {
                    let currentObj = this;
                    axios.delete(this.$api_url + '/delete-conversion-rate/' + code + '/' + month + '/' + year)
                        .then(function (response) {
                            if (response.data.success) {
                                this.$bvToast.toast('Deleted!', { title: `Success`, variant: 'success', solid: true });
                                this.getCurrencyRates();
                            } else {
                                this.$bvToast.toast('Unable to delete!', { title: `Failed`, variant: 'danger', solid: true });
                            }
                        }.bind(this));
                }
            }).catch(function (error) { currentObj.serverError(error); });
        },
        getAllCurrencies: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/get-conversion-currencies').then(function (response) {
                this.currencies = response.data;
                if (this.currencies.length == 0) {
                    this.blankmsg = "Nothing found.";
                } else {
                    this.currency_lists = Object.values(this.currencies)
                        .filter(item => item.status === "Active")
                        .map((item, index) => ({ value: index + 1, text: item.code }));
                    this.currency_lists.unshift({ value: 0, text: "Select/NA" });
                    this.getActiveCurrency();
                }
                this.showoverlay = false;
            }.bind(this));
        },
        getActiveCurrency: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/get-active-currency').then(function (response) {
                let currency_code = response.data;
                this.currency_selected = this.currency_lists.findIndex(item => item.text === currency_code);
                this.showoverlay = false;
            }.bind(this));
        },
        deleteCurrency: function (x) {
            let currency_text = this.currency_lists[this.currency_selected]['text'];
            if (currency_text == x) {
                this.$bvToast.toast('You cannot delete active currency!', { title: `Failed`, variant: 'danger', solid: true });
                return;
            }
            this.$bvModal.msgBoxConfirm('Please confirm if you want to delete this currency. All rates associated with it will be removed.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            }).then(value => {
                if (value) {
                    let currentObj = this;
                    axios.delete(this.$api_url + '/delete-conversion-currency/' + x)
                        .then(function (response) {
                            if (response.data.success) {
                                this.$bvToast.toast('Deleted!', { title: `Success`, variant: 'success', solid: true });
                                this.getAllCurrencies();
                            } else {
                                let error_msg = 'Unable to delete!';
                                if (response.data.error && response.data.message) error_msg = response.data.message;
                                this.$bvToast.toast(error_msg, { title: `Failed`, variant: 'danger', solid: true });
                            }
                        }.bind(this));
                }
            }).catch(function (error) { currentObj.serverError(error); });
        },
        updateCurrency() {
            let cur_val = this.currency_selected;
            let cur_val_text = this.currency_lists[cur_val].text;
            this.showoverlay = true;
            let formData = new FormData();
            formData.append("selected_currencies", cur_val_text);
            axios.post(this.$api_url + '/update-active-currency', formData)
                .then(function (response) {
                    if (response.data.success)
                        this.$bvToast.toast("Saved", { title: `Success`, variant: 'success', solid: true });
                    else
                        this.$bvToast.toast('Unable to update!', { title: `Failed`, variant: 'danger', solid: true });
                }.bind(this))
                .catch(function (error) { currentObj.serverError(error); });
            this.showoverlay = false;
        },
        updateStatus(currency_code, upd_status) {
            this.showoverlay = true;
            let formData = new FormData();
            formData.append("code", currency_code);
            formData.append("status", upd_status);
            axios.post(this.$api_url + '/update-currency-status', formData)
                .then(function (response) {
                    if (response.data.success) {
                        this.$bvToast.toast("Saved", { title: `Success`, variant: 'success', solid: true });
                        this.getAllCurrencies();
                    } else {
                        this.$bvToast.toast('Unable to update!', { title: `Failed`, variant: 'danger', solid: true });
                    }
                }.bind(this))
                .catch(function (error) { currentObj.serverError(error); });
            this.showoverlay = false;
        },
        // Sohel: New mappings update
        updateReportSettings() {
            this.showoverlay = true;
            let formData = new FormData();
            formData.append("report_total_row_setting", this.report_total_row_setting);
            axios.post(this.$api_url + '/update-currency-report-settings', formData)
                .then(function (response) {
                    if (response.data.success)
                        this.$bvToast.toast("Saved", { title: `Success`, variant: 'success', solid: true });
                    else
                        this.$bvToast.toast('Unable to update!', { title: `Failed`, variant: 'danger', solid: true });
                }.bind(this))
                .catch(function (error) { currentObj.serverError(error); });
            this.showoverlay = false;
        },
        getReportSettings: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/get-currency-report-settings').then(function (response) {
                if (response.data) {
                    this.report_total_row_setting = response.data;
                }
                this.showoverlay = false;
            }.bind(this));
        },
        // Sohel: New mappings update
    },
    created: function () {
        const currentYear = new Date().getFullYear();
        this.selected_year = currentYear;
        this.year = [
            { value: currentYear - 5, text: `${currentYear - 5}` },
            { value: currentYear - 4, text: `${currentYear - 4}` },
            { value: currentYear - 3, text: `${currentYear - 3}` },
            { value: currentYear - 2, text: `${currentYear - 2}` },
            { value: currentYear - 1, text: `${currentYear - 1}` },
            { value: currentYear, text: `${currentYear}` },
            { value: currentYear + 1, text: `${currentYear + 1}` }
        ];
        this.getAllCurrencies();
        // Sohel: New mappings update
        this.getReportSettings();
        // Sohel: New mappings update
    },
    computed: {
        filteredData() {
            let filtered_list = this.currencies;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                });
                if (filtered_list.length == 0) this.blankmsg = "Nothing found.";
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        filteredDataRates() {
            let filtered_rates = this.rates_data;
            if (this.rate_search) {
                filtered_rates = filtered_rates.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key]).toLowerCase().indexOf(this.rate_search.toLowerCase()) > -1;
                    });
                });
                if (filtered_rates.length == 0) this.blankmsgrates = "Nothing found.";
            }
            return filtered_rates;
        },
        paginatedDataRates() {
            return this.retespaginate(this.filteredDataRates, this.rates_length, this.rates_pagination.currentPage);
        },
    }
}
</script>
